import axios from 'axios'
import ConfigProvider from 'balkerne-core/config'
import {
  captureApiFailure,
  captureApiSuccess,
  getClientVersion,
  getSessionId,
} from 'balkerne-core/observability'

export const createApi = () => {
  const instance = axios.create({
    baseURL: ConfigProvider.backendEndpoint,
    responseType: 'json',
  })

  instance.interceptors.request.use(request => {
    request.headers = request.headers ?? {}
    request.metadata = {
      startedAt: Date.now(),
      sessionId: getSessionId(),
    }
    request.headers['x-session-id'] = request.metadata.sessionId
    request.headers['x-client-version'] = getClientVersion()
    return request
  })

  instance.interceptors.response.use(
    response => {
      const startedAt = response.config?.metadata?.startedAt ?? Date.now()
      captureApiSuccess({
        method: response.config?.method,
        url: response.config?.url,
        statusCode: response.status,
        durationMs: Date.now() - startedAt,
        requestId: response.headers?.['x-request-id'],
      })
      return response
    },
    error => {
      const startedAt = error.config?.metadata?.startedAt ?? Date.now()
      captureApiFailure({
        method: error.config?.method,
        url: error.config?.url,
        statusCode: error.response?.status,
        durationMs: Date.now() - startedAt,
        requestId: error.response?.headers?.['x-request-id'],
        error: error.message,
      })
      return Promise.reject(error)
    },
  )

  return instance
}

// This is the main API instance
export const api = createApi()

export default api
